module.exports = __webpack_public_path__ + "img/hori3.60cd266a.png";